import { InvoiceForm, InvoicesList } from './Invoicing'
import { InvoiceComms } from './Comms'

export { InvoiceForm, InvoicesList, InvoiceComms }

export { default as MedicalAidPaymentList } from './medical-aid-payment-list'
export { default as Reports } from './reports'
export { default as MedicalAidPaymentForm } from './medical-aid-payment-form'
export { default as PatientPaymentForm } from './patient-payment-form'
export { default as RemittanceForm } from './Remittances/components/RemittanceForm'

export default {
  InvoiceForm,
  InvoicesList,
  InvoiceComms,
  MedicalAidPaymentList: require('./medical-aid-payment-list').default,
  Reports: require('./reports').default,
  MedicalAidPaymentForm: require('./medical-aid-payment-form').default,
  PatientPaymentForm: require('./patient-payment-form').default,
  RemittanceForm: require('./Remittances/components/RemittanceForm').default
}
